// src/pages/NotFound.js
import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <Container maxWidth="sm" sx={{ mt: 5, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Button variant="contained" component={Link} to="/">
        Go to Home
      </Button>
    </Container>
  );
}

export default NotFound;